<template>
  <v-card>
    <v-toolbar card prominent top offet-y v-bind:class="{'fixedToolbar' : !drawer}" style="z-index: 2;">
      <v-toolbar-title class="headline grey-text">New Income</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click.native="addIncomeCheck($v.currentIncome)">
        <v-icon color="green">fas fa-check</v-icon>
      </v-btn>
      <v-btn icon @click.native="$router.push({ path: '/dashboard/income' })">
        <v-icon color="red">fas fa-times</v-icon>
      </v-btn>
    </v-toolbar>

    <v-card-text style="padding-top: 0;">
      <v-container grid-list-md v-bind:class="{'padContent': !drawer}">
        <v-layout wrap>
          <v-flex x12>
            <v-autocomplete v-bind:items="curriencies"
                            v-model="currentIncome.currency"
                            label="Currency"
                            chips
                            hint="What Currency is this Income in?"
                            persistent-hint
                            :error-messages="currencyErrors"
                            @input="$v.currentIncome.currency.$touch(), adjustCurrency()"
                            @blur="$v.currentIncome.currency.$touch()"></v-autocomplete>
          </v-flex>
          <v-flex xs12>
            <v-text-field label="Income Name" v-model="currentIncome.incomeName"
                          :error-messages="incomeNameErrors"
                          @input="$v.currentIncome.incomeName.$touch()"
                          @blur="$v.currentIncome.incomeName.$touch()"></v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-autocomplete v-bind:items="account"
                            v-model="currentIncome.account"
                            label="Account"
                            chips
                            prepend-icon="fas fa-university"
                            hint="What Account does this belong to?"
                            persistent-hint
                            :error-messages="accountErrors"
                            @input="$v.currentIncome.account.$touch(), adjustCurrency()"
                            @blur="$v.currentIncome.account.$touch()"></v-autocomplete>
          </v-flex>
          <v-flex xs12>
            <v-autocomplete v-bind:items="category"
                            v-model="currentIncome.category"
                            label="Category"
                            chips
                            prepend-icon="fa-tag"
                            hint="What Category does this belong to?"
                            persistent-hint
                            :error-messages="categoryErrors"
                            @input="$v.currentIncome.category.$touch()"
                            @blur="$v.currentIncome.category.$touch()"></v-autocomplete>
          </v-flex>
          <v-flex xs12 v-if="conversion">
            <v-text-field label="Currency Conversion"
                          prepend-icon="fas fa-balance-scale"
                          v-model="currentIncome.currencyConversion.conversionRate"
                          @click.prevent="getCurrencyConvertionRate()"
                          @focus="getCurrencyConvertionRate()"
                          :error-messages="currencyConversionErrors"
                          @input="$v.currentIncome.currencyConversion.$touch()"
                          @blur="$v.currentIncome.currencyConversion.$touch()"></v-text-field>
            <CurrencyConverter ref="converter" v-on:conversionRate="setCurrencyConversionRate($event)"></CurrencyConverter>
          </v-flex>
          <v-flex xs12 v-if="conversion">
            <v-text-field label="Amount" prepend-icon="fas fa-money-bill" type="number" min="1"
                          v-model="currentIncome.foreignCurrencyAmount"
                          :error-messages="foreignCurrencyAmountErrors"
                          @input="$v.currentIncome.foreignCurrencyAmount.$touch(), calculateConvertedAmount()"
                          @blur="$v.currentIncome.foreignCurrencyAmount.$touch()"></v-text-field>
          </v-flex>
          <v-flex xs12 v-if="!conversion">
            <v-text-field label="Income Amount" prepend-icon="fa-money-bill-alt" type="number" min="1"
                          v-model="currentIncome.incomeAmount"
                          :error-messages="incomeAmountErrors"
                          @input="$v.currentIncome.incomeAmount.$touch()"
                          @blur="$v.currentIncome.incomeAmount.$touch()"></v-text-field>
          </v-flex>
          <MoneyCalculator v-if="calculator"></MoneyCalculator>
          <v-flex xs12 v-if="conversion">
            <v-text-field label="Converted Amount" prepend-icon="fa-money-bill-alt"
                          v-model="currentIncome.incomeAmount"></v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-text-field label="Comment" prepend-icon="fa-comment" v-model="currentIncome.comment"></v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-switch v-model="recurringIncome"
                      label="Recurring Income"></v-switch>
          </v-flex>
          <v-flex xs6 v-if="!recurringIncome">
            <v-dialog ref="dialog"
                      persistent
                      lazy
                      v-model="addModelIncomeDate"
                      full-width
                      width="290px"
                      :return-value.sync="currentIncome.incomeDate">
              <v-text-field slot="activator"
                            label="Income Date"
                            v-model="currentIncome.incomeDate"
                            prepend-icon="event"
                            :error-messages="incomeDateErrors"
                            @input="$v.currentIncome.incomeDate.$touch()"
                            @blur="$v.currentIncome.incomeDate.$touch()"
                            readonly></v-text-field>
              <v-date-picker v-model="currentIncome.incomeDate" scrollable>
                <v-spacer></v-spacer>
                <v-btn flat color="primary" @click="addModelIncomeDate = false">Cancel</v-btn>
                <v-btn flat color="primary" @click="$refs.dialog.save(currentIncome.incomeDate)">OK</v-btn>
              </v-date-picker>
            </v-dialog>
          </v-flex>
          <v-flex xs6 v-if="!recurringIncome">
            <v-dialog ref="timemenu"
                      persistent
                      v-model="timemenuvisibilty"
                      lazy
                      full-width
                      width="290px"
                      :return-value.sync="currentIncome.incomeTime">
              <v-text-field slot="activator"
                            label="Time Picker"
                            v-model="currentIncome.incomeTime"
                            prepend-icon="access_time"
                            readonly></v-text-field>
              <v-time-picker v-model="currentIncome.incomeTime" actions>
                <v-spacer></v-spacer>
                <v-btn flat color="primary" @click="timemenuvisibilty = false">Cancel</v-btn>
                <v-btn flat color="primary" @click="$refs.timemenu.save(currentIncome.incomeTime)">OK</v-btn>
              </v-time-picker>
            </v-dialog>
          </v-flex>
          <v-flex xs12 v-if="recurringIncome">
            <v-layout wrap>
              <v-flex xs6>
                <v-text-field label="Repeat Every" type="number" min="1" max="60" v-model="currentIncome.repeat"></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-select v-model="currentIncome.cycle"
                          :items="['Day','Week','Month','Year']"></v-select>
              </v-flex>
            </v-layout>
            <v-radio-group v-model="currentIncome.period" row>
              <v-radio label="Forever" value="Forever"></v-radio>
              <v-radio label="For Number of cycles" value="For"></v-radio>
            </v-radio-group>
            <v-text-field v-if="currentIncome.period === 'For'" label="Number of cycles" type="number" min="1" max="60" v-model="currentIncome.numberOfCycles"></v-text-field>
            <v-dialog ref="goesOff"
                      persistent
                      lazy
                      v-model="addModelGoesOff"
                      full-width
                      width="290px"
                      :return-value.sync="currentIncome.goesOffFirst">
              <v-text-field slot="activator"
                            label="Start Date"
                            v-model="currentIncome.goesOffFirst"
                            prepend-icon="event"
                            readonly></v-text-field>
              <v-date-picker v-model="currentIncome.goesOffFirst" scrollable>
                <v-spacer></v-spacer>
                <v-btn flat color="primary" @click="addModelGoesOff = false">Cancel</v-btn>
                <v-btn flat color="primary" @click="$refs.goesOff.save(currentIncome.goesOffFirst)">OK</v-btn>
              </v-date-picker>
            </v-dialog>
          </v-flex>
        </v-layout>
      </v-container>

    </v-card-text>

  </v-card>
</template>

<script>
  import { validationMixin } from 'vuelidate'
  import { required, minValue } from 'vuelidate/lib/validators'
  
  import { globalFunctions } from '../../javascript/globalFunctions'
  import { accountManager } from '../../javascript/accountManager'
  import { incomeManager } from '../../javascript/incomeManager'

  import currencyConverter from '../../components/reuseable/currencyConverter/currencyConverter.vue'
  import MoneyCalculator from '../../components/reuseable/moneyCalculator/MoneyCalculator.vue'

  export default {
    mixins: [validationMixin],
    components: {
      'CurrencyConverter': currencyConverter,
      'MoneyCalculator': MoneyCalculator
    },
    props: ['drawer'],
    data() {
      return {
        account: [],
        category: ["cat"],
        curriencies: ["USD", "JMD"],
        OneTime: false,
        Recurring: false,
        calculator: true,
        type: 'OneTime',
        conversion: false,
        recurringIncome: false,
        addModelIncomeDate: false,
        addModelGoesOff: false,
        timemenuvisibilty: false,
        sameIncome: false,
        currentIncome: {
          id: 0,
          incomeName: '',
          account: '',
          incomeType: '',
          foreignCurrencyAmount: 0,
          incomeAmount: 0,
          currencyConversion: {},
          currency: '',
          incomeDate: '',
          incomeTime: '',
          comment: '',
          category: '',

          //Recurring
          repeat: 1,
          cycle: '',
          period: '',
          numberOfCycles: 1,
          goesOffFirst: '',

          //State of Current Object
          objectState: 'New',
          show: false
        },
        items: []
      }
    },
    computed: {
      incomeNameErrors() {
        const errors = []
        if (!this.$v.currentIncome.incomeName.$dirty) return errors
        this.sameIncome && errors.push('A Income already has this Name. Enter a new Name of update Income')
        !this.$v.currentIncome.incomeName.required && errors.push('Income Name is required')
        return errors
      },
      accountErrors() {
        const errors = []
        if (!this.$v.currentIncome.account.$dirty) return errors
        !this.$v.currentIncome.account.required && errors.push('Account is required')
        return errors
      },
      currencyErrors() {
        const errors = []
        if (!this.$v.currentIncome.currency.$dirty) return errors
        !this.$v.currentIncome.currency.required && errors.push('Currency is required')
        return errors
      },
      currencyConversionErrors() {
        const errors = []
        if (!this.$v.currentIncome.currencyConversion.$dirty) return errors
        !this.$v.currentIncome.currencyConversion.required && errors.push('Currency Conversion is required')
        return errors
      },
      categoryErrors() {
        const errors = []
        if (!this.$v.currentIncome.category.$dirty) return errors
        !this.$v.currentIncome.category.required && errors.push('Category is required')
        return errors
      },
      foreignCurrencyAmountErrors() {
        const errors = []
        if (!this.$v.currentIncome.foreignCurrencyAmount.$dirty && !this.$v.currentIncome.foreignCurrencyAmount.$dirty) return errors
        !this.$v.currentIncome.foreignCurrencyAmount.minValue && !this.$v.currentIncome.foreignCurrencyAmount  .minValue && errors.push('Amount must be at least 1')
        return errors
      },
      incomeAmountErrors() {
        const errors = []
        if (!this.$v.currentIncome.incomeAmount.$dirty && !this.$v.currentIncome.incomeAmount.$dirty) return errors
        !this.$v.currentIncome.incomeAmount.minValue && !this.$v.currentIncome.incomeAmount.minValue && errors.push('Income Amount must be at least 1')
        return errors
      },
      incomeDateErrors() {
        const errors = []
       if (!this.$v.currentIncome.incomeDate.$dirty) return errors
       !this.$v.currentIncome.incomeDate && errors.push('Income Date is required')
        return errors
      },
    },
    methods: {
      adjustCurrency: function () {
        if (this.currentIncome.account !== '') {
          let acc = accountManager.getAccountByName(this.currentIncome.account)

          if (this.currentIncome.currency === '') {
            this.currentIncome.currency = acc.accountCurrency
          }
          else if (this.currentIncome.currency !== acc.accountCurrency) {
            this.conversion = true
          }
          else if (this.currentIncome.currency === acc.accountCurrency) {
            this.conversion = false
          }
        }
      },
      getCurrencyConvertionRate: function () {
        this.$refs.converter.showConverter()

        let acc = accountManager.getAccountByName(this.currentIncome.account)

        this.$refs.converter.getcurrencyData(this.currentIncome.currency, acc.accountCurrency)
      },
      setCurrencyConversionRate: function (data) {
        this.currentIncome.currencyConversion = data
      },
      updateDateAndTime: function () {
        this.currentIncome.incomeDate = globalFunctions.getCurrentDateForPicker()
        this.currentIncome.incomeTime = globalFunctions.getCurrentTimeForPicker()
      },
      incomeCheck: function ($v) {
        $v.$touch(); //Triggers Error Messages

        if (this.currentIncome.incomeAmount <= 0 || !globalFunctions.isIntOrFloat(this.currentIncome.incomeAmount) || this.currentIncome.incomeAmount === "") { this.currentIncome.incomeAmount = 0 }

        if ($v.incomeName.$invalid || $v.category.$invalid || $v.account.$invalid) {
          return false
        }

        if (this.recurringIncome) {
          this.currentIncome.incomeType = "Recurring"
        } else if (!this.recurringIncome) {
          this.currentIncome.incomeType = "OneTime"
        }

        for (let i = 0; i < this.items.length; i++) {
          if (this.items[i].incomeName.toLowerCase() === this.currentIncome.incomeName.toLowerCase()) {
            this.sameIncome = true
            return false
          }
          if (i === this.items.length - 1) {
            this.sameIncome = false
          }
        }

        return true
      },
      addIncomeCheck: function ($v) {
        if (this.incomeCheck($v)) {
          this.addIncome();
        }
      },
      addIncome: function () {
        incomeManager.addIncome(this.currentIncome)

        this.createTransactionIfNeeded()

        this.$router.push({ path: '/dashboard/income' })
      },
      createTransactionIfNeeded: function () {
        if (this.checkIfTransactionIsNeeded) {
          incomeManager.createTransactionFromIncome(this.currentIncome)
        }
      },
      checkIfTransactionIsNeeded: function () {
        let today = new Date()
        let incomeTime = new Date(this.currentIncome.incomeDate)

        if (today.getTime() === incomeTime.getTime()) {
          return true
        }

        return false
      },
      calculateConvertedAmount: function () {
        if (this.currentIncome.foreignCurrencyAmount !== 0 && this.currentIncome.foreignCurrencyAmount !== '' && this.currentIncome.currencyConversion.conversionRate !== '') {
          this.currentIncome.incomeAmount = parseFloat(this.currentIncome.foreignCurrencyAmount) * parseFloat(this.currentIncome.currencyConversion.conversionRate)
        }
        else {
          this.currentIncome.incomeAmount = 0
        }
      }
    },
    watch: {
      "currentIncome.currencyConversion": function () {
        this.calculateConvertedAmount()
      }
    },
    beforeMount() {
      this.items = this.$store.state.Incomes

      let cat = this.$store.state.Categories
      for (let i = 0; i < cat.length; i++) {
        this.category.push(cat[i].categoryName)
      }
        
      let acc = this.$store.state.Accounts
      for (let i = 0; i < acc.length; i++) {
        this.account.push(acc[i].accountName)
      }

      this.updateDateAndTime()
    },
    validations: {
      currentIncome: {
        incomeName: {
          required
        },
        account: {
          required
        },
        currency: {
          required
        },
        currencyConversion: {
          required
        },
        category: {
          required
        },
        foreignCurrencyAmount: {
          required,
          minValue: minValue(1)
        },
        incomeAmount: {
          required,
          minValue: minValue(1)
        },
        incomeDate: {
          required
        }
      }
    }
  }

</script>



// WEBPACK FOOTER //
// src/components/income/AddIncomes.vue